import React from 'react'

import { RichText } from '@uswitch/ev-core/react'
import { Card, Icon } from '../../../atoms'

const CallOutCard = ({ content, jsonBody = {}, brand }) => {
  return (
    <Card
      className='CallOutCard'
      style={{
        backgroundColor: jsonBody.backgroundColor,
      }}
    >
      {(jsonBody.iconText || jsonBody.icon) && (
        <div
          className='CallOutCard-top-cta-wrapper'
          style={{
            backgroundColor: jsonBody.ctaBackgroundColor,
            color: jsonBody.ctaColor,
          }}
        >
          <div className='CallOutCard-top-cta-wrapper-inner'>
            {jsonBody.icon && (
              <div className='CallOutCard-icon-wrapper'>
                <Icon glyph={jsonBody.icon} brand={brand} ariaLabel={jsonBody.icon} size={24} />
              </div>
            )}
            {jsonBody.iconText && (
              <span style={{ color: jsonBody.ctaColor }}>{jsonBody.iconText}</span>
            )}
          </div>
        </div>
      )}
      <RichText content={content.content} />
    </Card>
  )
}

export default CallOutCard
